// previously order.rapid.ts (Rapid Orders feature)
import type { OrderDetails } from '@/entities/order/model'
import type { DisplayState } from '@/entities/state/model'
import { formatTime } from '@/shared/lib/dayjs'

interface GetPanelOrderStatusProps {
  order: OrderDetails
  displayState?: DisplayState
  withoutBackdrop?: boolean
  panelStatuses: Set<string>
}

interface GetPanelOrderStatusReturn {
  statusText: string
  statusDisplayState?: DisplayState
  isPanelOrderContext: boolean
}

export function getPanelOrderStatus({
  order,
  displayState,
  withoutBackdrop,
  panelStatuses,
}: GetPanelOrderStatusProps): GetPanelOrderStatusReturn {
  const isPanelOrderContext = Boolean(withoutBackdrop && panelStatuses.has(order.status))
  const orderedTime = order.orderActivationTime
    ? `Order at ${formatTime(order.orderActivationTime, 'h:mm A')}`
    : 'Order at unknown time'

  const statusDisplayState = isPanelOrderContext && displayState
    ? { ...displayState, stateDisplayName: orderedTime }
    : displayState

  const statusText = isPanelOrderContext ? orderedTime : order.status

  return {
    statusText,
    statusDisplayState,
    isPanelOrderContext,
  }
}
